import React from "react";
import { motion } from "framer-motion";
import svg from "../../assets/about/missionSVG.png";
import LucideIcon from "utils/LucideIcon";
import { IOurMission } from "Interfaces/interface.informationalPages";

const SectionOurMission: React.FC<IOurMission> = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut" as const,
      },
    },
  };

  return (
    <div className="pb-16 pt-20 px-4" id="work">
      <div className="max-w-7xl mx-auto">
        {/* Mission Section */}
        <motion.section
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          <motion.h2
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <div className="flex items-center md:text-left justify-center md:justify-start mb-4">
              <LucideIcon
                name="Target"
                className="w-10 h-10 text-blue-900 hover:text-blue-900 hidden md:inline-block mr-3"
              />
              <h2 className="text-4xl md:text-5xl font-bold font-inter text-secondary-gradient bg-clip-text text-transparent">
                Our Mission
              </h2>
            </div>
          </motion.h2>
          <motion.div
            className="w-24 h-1 bg-secondary-gradient mx-auto md:mx-0 md:ml-14 mb-8 rounded-xl"
            initial={{ width: 0 }}
            whileInView={{ width: 96 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            viewport={{ amount: 0.2 }}
          ></motion.div>

          <motion.div
            className="mb-12 lg:grid grid-cols-2 gap-4"
            variants={itemVariants}
          >
            <div className="text-center lg:text-left">
              <p className="text-xl text-gray-700 leading-relaxed font-body">
                At 360Customizer, we make{" "}
                <span className="font-semibold text-orange-600">
                  customization accessible to every business,
                </span>{" "}
                helping brands express their unique identity with purpose.{" "}
                Through{" "}
                <span className="font-semibold text-green-600">
                  creativity, technology, and scale,
                </span>{" "}
                we simplify personalized gifting and branding to create{" "}
                <span className="font-semibold text-purple-600">
                  meaningful, effortless experiences
                </span>{" "}
                that connect and inspire.
              </p>
            </div>

            <div className="max-w-80 flex justify-center items-center md:ml-20">
              <img
                src={`https://360customizer.360customizer.com/pm-panel-qa/123_images/370a4815-53c0-4c1d-b25c-af4c625dc161-9812.jpg`}
                className="object-contain mix-blend-multiply"
              />
            </div>
          </motion.div>
        </motion.section>
      </div>
    </div>
  );
};

export default SectionOurMission;
